import React, { useState, useEffect } from 'react';
import './AddProductForm.css';

const AddProductForm = ({ onClose, onAddProductComplete }) => {
  const [inventory, setProduct] = useState({
    item_first_name: '',
    item_second_name: '',
    item_code: '',
    serial_number: '',
    barcode: '',
    location_id: '',
    classification_id: '',
    department_id: '',
    quantity: 1,
    price: '0'
  });

  const [locations, setLocations] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  /* =========================
     Fetch dropdown data
  ========================= */
  useEffect(() => {
    fetch('/api/locations')
      .then(res => res.json())
      .then(setLocations)
      .catch(err => console.error('Locations error:', err));

    fetch('/api/classifications')
      .then(res => res.json())
      .then(setClassifications)
      .catch(err => console.error('Classifications error:', err));

    fetch('/api/departments')
      .then(res => res.json())
      .then(setDepartments)
      .catch(err => console.error('Departments error:', err));
  }, []);

  /* =========================
     Handle change
  ========================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setProduct(prev => ({
      ...prev,
      [name]: value
    }));
  };

  /* =========================
     Handle submit
  ========================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/products', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inventory)
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Failed to add product');
      }

      console.log('✅ Product added:', data);

      onAddProductComplete(); // refresh parent
      onClose(); // close modal

    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     Render
  ========================= */
  return (
    <div className="modal-overlay">
      <div className="modal-content">

        {/* Close */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Product</h3>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>

          {/* First Name */}
          <div className="form-group">
            <label id="add-product-label">First Name</label>
            <input
              id="add-product-input"
              type="text"
              name="item_first_name"
              value={inventory.item_first_name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Second Name */}
          <div className="form-group">
            <label id="add-product-label">Second Name</label>
            <input
              id="add-product-input"
              type="text"
              name="item_second_name"
              value={inventory.item_second_name}
              onChange={handleChange}
            />
          </div>

          {/* Product Code */}
          <div className="form-group">
            <label id="add-product-label">Product Code</label>
            <input
              id="add-product-input"
              type="text"
              name="item_code"
              value={inventory.item_code}
              onChange={handleChange}
              required
            />
          </div>

          {/* Serial */}
          <div className="form-group">
            <label id="add-product-label">Serial Number</label>
            <input
              id="add-product-input"
              type="text"
              name="serial_number"
              value={inventory.serial_number}
              onChange={handleChange}
            />
          </div>

          {/* Barcode */}
          <div className="form-group">
            <label id="add-product-label">Barcode (GTIN)</label>
            <input
              id="add-product-input"
              type="text"
              name="barcode"
              value={inventory.barcode}
              onChange={handleChange}
            />
          </div>

          {/* Classification */}
          <div className="form-group">
            <label id="add-product-label">Asset Classification</label>
            <select
              id="add-product-input"
              name="classification_id"
              value={inventory.classification_id}
              onChange={handleChange}
              required
            >
              <option value="">Select Classification</option>
              {classifications.map(c => (
                <option key={c.classification_id} value={c.classification_id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {/* Location */}
          <div className="form-group">
            <label id="add-product-label">Location</label>
            <select
              id="add-product-input"
              name="location_id"
              value={inventory.location_id}
              onChange={handleChange}
              required
            >
              <option value="">Select Location</option>
              {locations.map(l => (
                <option key={l.location_id} value={l.location_id}>
                  {l.location_name}
                </option>
              ))}
            </select>
          </div>

          {/* Department */}
          <div className="form-group">
            <label id="add-product-label">Department</label>
            <select
              id="add-product-input"
              name="department_id"
              value={inventory.department_id}
              onChange={handleChange}
            >
              <option value="">Optional</option>
              {departments.map(d => (
                <option key={d.department_id} value={d.department_id}>
                  {d.department_name}
                </option>
              ))}
            </select>
          </div>

          {/* Quantity */}
          <div className="form-group">
            <label id="add-product-label">Quantity</label>
            <input
              id="add-product-input"
              type="number"
              name="quantity"
              value={inventory.quantity}
              onChange={handleChange}
              min="1"
            />
          </div>

          {/* Price */}
          <div className="form-group">
            <label id="add-product-label">Price</label>
            <input
              id="add-product-input"
              type="number"
              name="price"
              value={inventory.price}
              onChange={handleChange}
              step="0.01"
            />
          </div>

          {/* Submit */}
          <div className='form-actions'>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Adding...' : 'Add Product'}
          </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default AddProductForm;